import { Ionicons } from '@expo/vector-icons';
import * as Font from 'expo-font';
import * as SplashScreen from 'expo-splash-screen';
import * as React from 'react';
import firebase from 'firebase';

export default function useCachedResources() {
  const [isLoadingComplete, setLoadingComplete] = React.useState(false);

  // Load any resources or data that we need prior to rendering the app
  React.useEffect(() => {
    async function loadResourcesAndDataAsync() {
      try {
        SplashScreen.preventAutoHideAsync();

        // Load fonts
        await Font.loadAsync({
          ...Ionicons.font,
        });
      } catch (e) {
        // We might want to provide this error information to an error reporting service
        console.warn(e);
      } finally {
        setLoadingComplete(true);
        SplashScreen.hideAsync();
      }
    }

    var config = {
      apiKey: "AIzaSyAw74O5b5cW4F3_D_w3DD1hkuCu03iv1yY",
      authDomain: "vyapar-myhomestore.firebaseapp.com",
      databaseURL: "https://vyapar-myhomestore.firebaseio.com",
      projectId: "vyapar-myhomestore",
      storageBucket: "vyapar-myhomestore.appspot.com",
      messagingSenderId: "1024029903016",
      appId: "1:1024029903016:web:19f482af2aacf5bb409a9d",
      measurementId: "G-DM07998L79"
    };
    firebase.initializeApp(config);

    loadResourcesAndDataAsync();
  }, []);

  return isLoadingComplete;
}
